// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"media_imageContainer___qznh","videoContainer":"media_videoContainer__viro_"};